import React, { PureComponent, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { FooterLogo, TwitterLogo, FbLogo, YtLogo, LinkedIn, Vaitor, Trip, Expedia, ExtremeWeb } from '../../Images'
import HyperLinkTours from './HyperLinkTours'
import whatsappIcon from "../../Images/whatsapp-icon.png";

const mapStateToProps = (state) => {
	return {
	}
}
const mapDispatchToProps = dispatch => ({

});

function WhatsAppButton() {
  const message = encodeURIComponent(
    "Hello, I want to inquire about your tours."
  );

  return (
    <a
      href={`https://wa.me/94704579679?text=${message}`}
      className="whatsapp-float home-whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={whatsappIcon} alt="WhatsApp Chat" />
    </a>
  );
}

class Footer extends PureComponent {

	constructor(props) {
		super(props);

		this.state = {

		}
	}
	

	render() {
		return (
			<Fragment>
				{this.props.hyperLink ? <HyperLinkTours /> : null}
				
				<div className="footer-div">
					<footer>
						<div className="container">
							<div className="row">
								<div className="col-lg-6">
									<div className="f-logo-sio">
										<a href="/">
											<img src={FooterLogo} width="266" height="40" alt="Beyond Escapes" />
										</a>

										<ul className="sociallinks">
											<li>
												<a href="https://twitter.com/beyondescapes" target="_blank" rel="noreferrer">
													<img src={TwitterLogo} width="18" height="14" alt="Twitter" />
												</a>
											</li>
											<li>
												<a href="https://www.facebook.com/beyondescapes" target="_blank" rel="noreferrer">
													<img src={FbLogo} width="10" height="18" alt="Facebook" />
												</a>
											</li>
											<li>
												<a href="https://www.youtube.com/channel/UCk5tpsK-VpPY1LhlJdsCIew" target="_blank" rel="noreferrer">
													<img src={YtLogo} width="16" height="21" alt="YouTube" />
												</a>
											</li>
											<li>
												<a href="https://www.linkedin.com/company/beyond-escapes" target="_blank" rel="noreferrer">
													<img src={LinkedIn} width="18" height="18" alt="LinkedIn" />
												</a>
											</li>
										</ul>

										<div className="clear"></div>

										<address>
											164/C/2,<br />
											New Kandy Road, Kothalawala,<br />
											Kaduwela,<br />
											Sri Lanka
										</address>

										<div className="mal-tel">
											<a href="tel:+94112579679">Hotline: +94 112 579 679</a>
											<a href="https://wa.me/94704579679">WhatsApp: +94 704 579 679</a>
											<a href="skype:beyond.escapes?call">Skype: beyond.escapes</a>
											<a href="mailto:info@beyondescapes.com">Mail: info@beyondescapes.com</a>
										</div>
									</div>
								</div>

								<div className="col-lg-6">
									<div className="fot-menu">
										<div className="fmnu">
											<h4>Customer care</h4>
											<ul>
												<li><a href="/customer-care#section1">Help Center</a></li>
												<li><a href="/customer-care#section2">Privacy Policy</a></li>
												<li><a href="/customer-care#section3">Cookie Policy</a></li>
												<li><a href="/customer-care#section4">Product Disclaimers</a></li>
												<li><a href="/customer-care#section5">Terms & Conditions</a></li>
											</ul>
										</div>

										<div className="fmnu">
											<h4>Site map</h4>
											<ul>
												<li><a href="/about-us">About Us</a></li>
												<li><a href="/contact-us">Contact us</a></li>
												<li><a href="/round-tours">Round Tours</a></li>
												<li><a href="/day-tours">Day Tours</a></li>
												<li><a href="/things-to-do">Things to do</a></li>
												<li><a href="/vehicle-transfers">Transfers</a></li>
												<li><a href="#">Bespoke Tours</a></li>
											</ul>
										</div>

										<div className="fmnu">
											<h4>Sites</h4>
											<ul>
												<li><a href="https://www.leopardnest.com/" target="_blank" rel="noreferrer">Leopard Nest</a></li>
												<li><a href="https://themiceteam.com/" target="_blank" rel="noreferrer">The MICE Team</a></li>
												<li><a href="#">BE Sports</a></li>
												<li><a href="#">Tour Lanka</a></li>
											</ul>
										</div>
									</div>
								</div>
							</div>

							<div className="fot-bot">
								<div className="row">
									<div className="col-lg-6">
										<div className="fot-los">
											<a href="https://www.viator.com/operator/8021?aid=trb1" target="_blank" rel="noreferrer">
												<img src={Vaitor} width="92" height="29" alt="Viator" />
											</a>
											<a href="https://www.tripadvisor.com/Attraction_Review-g293962-d6781127-Reviews-Beyond_Escapes-Colombo_Western_Province.html" target="_blank" rel="noreferrer">
												<img src={Trip} width="141" height="22" alt="TripAdvisor" />
											</a>
											<a href="https://www.beyondescapes.com/" target="_blank" rel="noreferrer">
												<img src={Expedia} width="102" height="29" alt="Expedia" />
											</a>
										</div>
									</div>

									<div className="col-lg-6">
										<div className="copy">
											<p>
												© Copyright {new Date().getFullYear()} Beyond Escapes | All Rights Reserved.
												<a href="https://www.extremewebdesigners.com/" target="_blank" rel="noreferrer"> Web design </a>
												by <img src={ExtremeWeb} width="14" height="14" alt="EWD" />
												<a href="https://www.extremewebdesigners.com/" target="_blank" rel="noreferrer"> EWD</a>
											</p>
										</div>
									</div>
								</div>
							</div>

						</div>
					</footer>
				</div>
				<WhatsAppButton />
			</Fragment>
		);
	}
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Footer);
